import ContactMessageEdit from "../../components/admin/contact-messages/ContactMessageEdit";
import AdminTemplate from "../../views/AdminTemplate";

const AdminContactMessageEditPage = () => {
  return (
    <AdminTemplate>
      <ContactMessageEdit />
    </AdminTemplate>
  );
};

export default AdminContactMessageEditPage;
